<template>
  <div class="zoom-phone-confirm-dialog">
    <div class="date-time-section">
      <strong class="time-period">{{ $t('vaApp.zoomPhone.confirmDialog.callDateTime', { startedAt: startTime, endedAt: endTime }) }}</strong>
    </div>
    <div class="message-section">
      <strong class="phone-number">{{ phoneNumber }}</strong>
      <span>{{ $t('vaApp.zoomPhone.confirmDialog.messageSuffix') }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatMonthDayTime } from '@/utils/date-time';

const props = defineProps<{
  startedAt: string;
  endedAt?: string;
  phoneNumber: string;
}>();

const startTime = computed(() => formatMonthDayTime(props.startedAt));
const endTime = computed(() =>
  formatMonthDayTime(props.endedAt ?? new Date().toISOString()),
);
</script>

<style lang="scss" scoped>
.zoom-phone-confirm-dialog {
  text-align: center;
  line-height: 1.8;
  padding: 8px 0;
}

.date-time-section {
  margin-bottom: 24px;
  font-size: 16px;

  .time-period {
    font-weight: 700;
  }
}

.message-section {
  font-size: 16px;
  line-height: 1.8;

  .phone-number {
    font-weight: 700;
  }
}
</style>
